import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './RetreatRegistrationForm.css';

const HimalayaRegistrationForm = () => {
  const navigate = useNavigate();

  const [status, setStatus] = useState('idle'); // idle | sending | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMsg('');

    try {
      const form = e.currentTarget;
      const formData = new FormData(form);

      const res = await fetch('https://formspree.io/f/xrbllyyd', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });

      if (res.ok) {
        setStatus('success');
        form.reset(); // clears the inputs
      } else {
        const data = await res.json().catch(() => ({}));
        setStatus('error');
        setErrorMsg(
          data?.errors?.[0]?.message ||
            'Something went wrong sending your registration. Please try again.'
        );
      }
    } catch (err) {
      setStatus('error');
      setErrorMsg('Network error. Please check your connection and try again.');
    }
  };

  return (
    <section className="registration-section">
      <form className="registration-form" onSubmit={handleSubmit}>
        <h2 className="registration-header">Himalayas Yoga Registration Form</h2>
        <p className="registration-subtext">
          Please do fill out the form, to help tailor your experience.
        </p>

        {/* ✅ Success / Error signal */}
        {status === 'success' && (
          <div
            style={{
              marginBottom: '1rem',
              padding: '0.75rem 1rem',
              borderRadius: '8px',
              background: '#D0F4DE',
              border: '1px solid rgba(0,0,0,0.08)',
              color: '#0b2f2f',
              fontWeight: 600,
            }}
          >
            ✅ Registration sent! Thank you — we’ll be in touch soon.
          </div>
        )}

        {status === 'error' && (
          <div
            style={{
              marginBottom: '1rem',
              padding: '0.75rem 1rem',
              borderRadius: '8px',
              background: '#ffe8e8',
              border: '1px solid rgba(0,0,0,0.08)',
              color: '#7a0010',
              fontWeight: 600,
            }}
          >
            ❌ {errorMsg}
          </div>
        )}

        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="fullName">Full Name:</label>
            <input id="fullName" type="text" name="Full Name" placeholder="Your name" required />
          </div>

          <div className="form-group">
            <label htmlFor="age">Age:</label>
            <input id="age" type="number" name="Age" placeholder="Your age" required />
          </div>

          <div className="form-group">
            <label htmlFor="nationality">Nationality:</label>
            <input
              id="nationality"
              type="text"
              name="Nationality"
              placeholder="e.g. Australian"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input id="email" type="email" name="Email" placeholder="Your email" required />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number (with country code):</label>
            <input
              id="phone"
              type="tel"
              name="Phone Number"
              placeholder="+61 412 345 678"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="emergency">Emergency Contact:</label>
            <input
              id="emergency"
              type="text"
              name="Emergency Contact"
              placeholder="Name & number"
              required
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="room">
              Single or double room (if double, are you coming with someone?):
            </label>
            <textarea
              id="room"
              name="Room Preference"
              placeholder="Single or Double room? If double, who are you coming with?"
              rows="2"
              required
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="diet">Dietary Restrictions:</label>
            <textarea
              id="diet"
              name="Dietary Restrictions"
              placeholder="e.g. vegan, gluten-free, nut allergy"
              rows="2"
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="yogaExperience">How long have you been practising yoga:</label>
            <input
              id="yogaExperience"
              type="text"
              name="Yoga Experience"
              placeholder="e.g. 2 years practicing vinyasa yoga"
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="goals">What are you hoping to get out of this retreat:</label>
            <textarea
              id="goals"
              name="Retreat Goals"
              placeholder="Share your intentions or personal goals..."
              rows="3"
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-button" disabled={status === 'sending'}>
            {status === 'sending' ? 'Sending…' : 'Submit Registration'}
          </button>

          <button type="button" className="back-button" onClick={() => navigate('/himalayas-retreat')}>
            ← Back to Retreat Page
          </button>
        </div>
      </form>
    </section>
  );
};

export default HimalayaRegistrationForm;
